/**
 * Format a mysql date (or date & time) (ie date with hypens) to d/mm/yyyy
 */

const formatDate = function(date) {
  if (!date) return null;

  let [year, month, day] = date.split("-");

  if (!day) return date; //must already be formated

  // incase a full date string with time is passed in eg 02-24-2019 10:13:27
  day = day.split(" ");
  let time = false;

  if (day.length > 1) time = day[1];

  day = parseInt(day[0], 10);

  if (time) return `${day}/${month}/${year} ${time}`;
  else return `${day}/${month}/${year}`;
};

export { formatDate };
